import { gql } from '@apollo/client';

export const GET_WRITERS_REPORT = gql`
  query titlesWritersReport(
    $writers: [String!]!
    $limit: Int
    $offset: Int
    $dateStart: DateTime
    $dateEnd: DateTime
    $sites: [String!]
    $searchText: String
    $status: Int
  ) {
    titlesWritersReport(
        writers: $writers
        filter: {
            limit: $limit
            offset: $offset
            dateStart: $dateStart
            dateEnd: $dateEnd
            sites: $sites
            status: $status
            searchText: $searchText
        }
    ) {
      reports {
        writerId
        article
        news
        translator
        others
      }
      total
    }
  }
`;

export const GET_WRITER_REPORTS_BY_ID = gql`
  query titlesReportByUserId(
    $writerId: String!
    $limit: Int
    $offset: Int
    $dateStart: DateTime
    $dateEnd: DateTime
    $sites: [String!]
    $status: Int
    $searchText: String
  ) {
    titlesReportByUserId(
        writerId: $writerId
        filter: {
            limit: $limit
            offset: $offset
            dateStart: $dateStart
            dateEnd: $dateEnd
            sites: $sites
            searchText: $searchText
            status: $status
        }
    ) {
      titles {
        title
        siteDomain
        niche
        tag
        status
        postUrl
      }
      total
    }
  }
`;
